export const ROOM_STATE_REPORT_ENDPOINT = `report/room_state`;
